import { render, staticRenderFns } from "./AutorizacionComponent.vue?vue&type=template&id=f3e0a838"
import script from "./AutorizacionComponent.vue?vue&type=script&lang=js"
export * from "./AutorizacionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports